import React from 'react';
import { Route, Switch } from 'react-router';

import Grades from './Grades';
import GradeGroups from './GradeGroups';
import Rates from './Rates';
import Languages from './Languages';
import Regions from './Regions';
import Countries from './Countries';
import Subjects from './Subjects';

const MasterRoutes = (
  <Route title="Master Data" breadcrumb={false} path="/master">
    <Switch>
      <Route path="/master/subject" title="Subjects" component={Subjects} />
      <Route
        path="/master/gradeGroup"
        title="Grade Groups"
        component={GradeGroups}
      />
      <Route path="/master/grade" title="Grades" component={Grades} />
      <Route path="/master/country" title="Countries" component={Countries} />
      <Route path="/master/region" title="Regions" component={Regions} />
      <Route path="/master/language" title="Languages" component={Languages} />
      <Route path="/master/rate" title="Rates" component={Rates} />
    </Switch>
  </Route>
);

export default MasterRoutes;



// WEBPACK FOOTER //
// ./src/components/master/MasterRoutes.js